import axios from 'axios';

const PRIMARY_SERVER_BASE_URL = process.env.REACT_APP_FIREBASE_PROJECT_ID === 'clubgrub-staging-v2'
  ? 'https://server-staging.clubgrub.co/api/v1/'
  : 'https://server.clubgrub.co/api/v1/';

export const refreshMenuCache = async (restaurantId) => {
  if (!restaurantId) {
    throw new Error('Restaurant ID is required to refresh the menu cache');
  }

  const response = await axios.post(
    `${PRIMARY_SERVER_BASE_URL}restaurant/refresh/menu/cache`,
    {
      restaurantId,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  console.log('Menu cache refresh response:', response.data);

  return response.data;
};